// Invoice Actions
import { createAsyncThunk } from '@reduxjs/toolkit';
import invoiceApi from '../../utils/api/invoiceApi';

export const fetchInvoices = createAsyncThunk(
  'invoices/fetchInvoices',
  async (params) => {
    const response = await invoiceApi.getInvoices(params);
    return response;
  }
);

export const fetchInvoiceById = createAsyncThunk(
  'invoices/fetchInvoiceById',
  async (invoiceId) => {
    const response = await invoiceApi.getInvoice(invoiceId);
    return response;
  }
);

export const createInvoice = createAsyncThunk(
  'invoices/createInvoice',
  async (invoice) => {
    const response = await invoiceApi.addInvoice(invoice);
    return response;
  }
);

export const updateInvoice = createAsyncThunk(
  'invoices/updateInvoice',
  async ({ invoiceId, invoice }) => {
    const response = await invoiceApi.updateInvoice(invoiceId, invoice);
    return response;
  }
);

export const removeInvoice = createAsyncThunk(
  'invoices/removeInvoice',
  async (invoiceId) => {
    const response = await invoiceApi.deleteInvoice(invoiceId);
    return response;
  }
);